import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import UserAvatar from '../../../../Shared/UserAvatar/UserAvatar'

function FeedItem({
  checked,
  title,
  body = '',
  thumbnail = null,
  createdAt,
  category,
  points,
}) {
  const itemChecked = checked ? '' : 'is-active'

  function formatedPoints() {
    if (points > 0) {
      return <span className="text-semibold text-green">+{points}</span>
    }
    return <span className="text-semibold text-red">{points}</span>
  }

  function guessTitle() {
    if (title && title.match(/<a [^>]+>([^<]+)<\/a>/)) {
      return title.match(/<a [^>]+>([^<]+)<\/a>/)[1]
    }
    if (window.App.config.username) {
      return window.App.config.username
    }
    return ''
  }

  return (
    <div className={`col-12 feed-list__item ${itemChecked}`}>
      <UserAvatar img={thumbnail} userName={guessTitle()} />
      <div className="feed-item__info">
        <div
          className="feed-item__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {body && <p className="u-mt10 u-mb0">{body}</p>}
        <div className="feed-item__secondary-info u-mt10">
          <span className="feed-item__date">
            {moment(createdAt, 'X').fromNow()}
          </span>
          <span className="text-semibold">{category}</span>
        </div>
      </div>
    </div>
  )
}

FeedItem.propTypes = {
  checked: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  thumbnail: PropTypes.string,
  createdAt: PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired,
}

export default FeedItem
